<template>
  <v-container class="py-0 d-flex flex-column justify-space-around fill-height">
    <v-sheet class="transparent" width="100%">
      <v-row justify="center" align="center">
        <v-col md="10">
          <v-row justify="center" align="center">
            <v-col
              v-for="item in menu"
              :key="item.title"
              cols="6"
              sm="4"
              md="4"
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    dark
                    :to="{ name: item.url }"
                    outlined
                    class="transparent rounded-xl transition-swing"
                    style="border:2px solid rgba(255, 255, 255, 0.3) !important"
                    :class="{ 'background-transparent-white': hover }"
                  >
                    <v-card-text class="d-flex flex-column align-center">
                      <v-img max-width="26%" min-width="52" :src="item.icon" />
                      <span class="body-sm-1 body-2 mt-3 font-weight-bold">
                        {{ item.title }}
                      </span>
                    </v-card-text>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        {
          title: 'Monitoring',
          icon: require('@/assets/icons/monitoring-alt.svg'),
          url: 'Map'
        },
        {
          title: 'Laporan',
          icon: require('@/assets/icons/laporan-alt.svg'),
          url: 'report'
        },
        {
          title: 'Dashboard',
          icon: require('@/assets/icons/dashboard-alt.svg'),
          url: 'dashboard'
        },
        {
          title: 'Pemberitahuan',
          icon: require('@/assets/icons/pengumuman-alt.svg'),
          url: 'announcement'
        },
        {
          title: 'Anggota',
          icon: require('@/assets/icons/anggota-alt.svg'),
          url: 'user'
        },
        {
          title: 'Wilayah',
          icon: require('@/assets/icons/unit-alt.svg'),
          url: 'unit'
        },
        {
          title: 'Event',
          icon: require('@/assets/icons/calendar-alt.png'),
          url: 'event'
        }
      ]
    };
  },
  created() {
    if (
      this.$store.state.user.accountAccountGroupId === '3' ||
      this.$store.state.user.accountAccountGroupId === '4'
    ) {
      this.$router.replace('/user');
    }
  }
};
</script>
<style lang="scss">
.background-transparent-white:before {
  opacity: 0.08 !important;
}
</style>
